// extracted by mini-css-extract-plugin
export default {"wrapper":"Directories_wrapper__dv30u","main":"Directories_main__63Gx2"};